import BlueButton from "../../../../common/BlueButton/BlueButton";
import LoadingDisplay from "../../../../common/LoadingDisplay/LoadingDisplay";
import "./selectedImagesCardDisplay.css";
import { useTranslation } from "react-i18next";

const SelectedImagesCardDisplay = ({
    item,
    removeItem,
    isButtonGray,
    contentRight,
    contentLeft,
    replaceSelectedTemplate,
}) => {
    const { t } = useTranslation("templatesPage");

    if (!contentRight) contentRight = <></>;
    if (!contentLeft) contentLeft = <></>;

    if (item.isGone)
        contentRight = (
            <>
                <h3>{t("selectedMemeHasBeenRemoved")}</h3>
            </>
        );

    if (!item) return <></>;

    let displayComponent = (
        <div className="ImageLoaderImageContainerContent">
            <div className="selectedTemplatesCardContent">
                <div className="selectedTemplatesCardContentHeadContainer">
                    <div className="selectedTemplatesCardContentHead">
                        <div className="selectedTemplatesCardImageBackButton">
                            <BlueButton
                                text="X"
                                isDark={true}
                                onClick={() => {
                                    removeItem(item);
                                }}
                                isGray={isButtonGray}
                            />
                        </div>
                        <div className="selectedTemplatesCardTitle">
                            <p>{item.name ? item.name : item.title}</p>
                        </div>
                    </div>
                    <div className="selectedTemplatesCardLineContainer">
                        <hr className="selectedTemplatesCardLine"></hr>
                    </div>
                </div>

                <div className="selectedTemplatesCardImageAndTitle">
                    <img
                        className="selectedTemplatesCardImageDisplay"
                        src={item.thumbnailUrl}
                        alt={item.title}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/imageNotFound.jpg";
                            item.thumbnailUrl = "/imageNotFound.jpg";
                            replaceSelectedTemplate({ ...item, isGone: true });
                        }}
                    />
                </div>

                <br />
                <div className="selectedTemplatesCardImageLoaderInputValues">
                    {!item.isEdit ? (
                        !item.isGone ? (
                            <>{contentLeft}</>
                        ) : (
                            <>{contentRight}</>
                        )
                    ) : (
                        <>{contentRight}</>
                    )}
                </div>
            </div>
        </div>
    );

    if (item.isLoading) {
        displayComponent = (
            <>
                <div className="selectedTemplatesCardContent">
                    <div className="selectedTemplatesCardLoadingDisplay">
                        <LoadingDisplay invert={true} />
                    </div>
                </div>
            </>
        );
    }

    return displayComponent;
};

export default SelectedImagesCardDisplay;
